export enum DateTimeError {
	START = 'start',
	STOP = 'stop',
	NONE = 'none'
}
